(function () {
  if (customElements.get('modular-configurator')) return;

  var DIRS = { E: [1, 0], S: [0, 1], W: [-1, 0], N: [0, -1] };
  var ORDER = ['E', 'S', 'W', 'N'];
  var CELL = 64;
  var GAP = 0;
  var PAD = 14;
  var CHEVRON_SVG =
    '<div class="seat-configurator__seat-chevron">' +
    '<svg class="icon icon-button-arrow" xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none" aria-hidden="true"><path d="M5 3L0.5 5.59808L0.5 0.401924L5 3Z" fill="currentColor"/></svg>' +
    '</div>';
  var ROTATE_SVG =
    '<svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M17.5 9.375C17.8452 9.375 18.125 9.65482 18.125 10V17.5C18.125 17.8452 17.8452 18.125 17.5 18.125H5C4.65482 18.125 4.375 17.8452 4.375 17.5V10C4.375 9.65482 4.65482 9.375 5 9.375H17.5ZM5.625 16.875H16.875V10.625H5.625V16.875Z" fill="currentColor"/>' +
    '<path d="M1.875 3.33301C1.875 2.98783 2.15482 2.70801 2.5 2.70801C2.84518 2.70801 3.125 2.98783 3.125 3.33301V6.45801H6.25C6.59518 6.45801 6.875 6.73783 6.875 7.08301C6.875 7.42819 6.59518 7.70801 6.25 7.70801H2.5C2.15482 7.70801 1.875 7.42819 1.875 7.08301V3.33301Z" fill="currentColor"/>' +
    '<path d="M10.0001 1.875C12.6786 1.875 15.0542 3.17195 16.5333 5.16927C16.7387 5.44667 16.6805 5.83788 16.4031 6.04329C16.1257 6.24865 15.7345 6.19037 15.5291 5.91309C14.2756 4.2204 12.2657 3.125 10.0001 3.125C7.7771 3.125 5.80046 4.17932 4.54275 5.81787C4.5302 5.83422 4.51697 5.85004 4.50287 5.86507L2.95583 7.51139C2.71948 7.76287 2.32357 7.77532 2.07204 7.53906C1.82057 7.30271 1.80811 6.9068 2.04437 6.65527L3.57514 5.02604C5.06035 3.11013 7.38612 1.875 10.0001 1.875Z" fill="currentColor"/>' +
    '</svg>';

  // Solid-color swatches for Color values that aren't a fabric photo below.
  // Add entries as 'value name (lowercased)': '#hexcode'.
  var COLOR_HEX_BY_VALUE = {};

  // Maps a role's `shape_type` (merchant-configured, Configurator Module
  // metaobject field) to how a single module renders in the top-view
  // layout: 'A' (armless, optionally with an arm marker on one side) or 'C'
  // (corner, optionally an extended chaise). Ported from the seat-
  // configurator's SEAT_TYPE_BY_VALUE, keyed by shape_type instead of a
  // free-text Orientation option value.
  var SHAPE_TYPE_TABLE = {
    armless: { type: 'A' },
    // A straight seat with an arm on one side, distinct from `armless` (no
    // arm) and from `corner` (its side block is a full backrest that turns
    // the chain 90°, not an arm) - confirmed against Anchor's real
    // Armrest Left/Right top-view photos.
    armrest_left: { type: 'A', armSide: 'left' },
    armrest_right: { type: 'A', armSide: 'right' },
    corner: { type: 'C', turn: 'R', chaise: false },
    corner_chaise: { type: 'C', turn: 'R', chaise: true },
    // Geometrically the same as armless - the real top-view photo is what
    // visually differentiates an ottoman, matching how the old seat-
    // configurator already treated any unrecognized orientation value.
    ottoman: { type: 'A' },
  };

  // How many units of this variant Shopify will actually let this order
  // claim. `inventory_quantity` only means anything when Shopify tracks
  // inventory for it and it isn't set to oversell - otherwise (custom/no
  // tracking, or "continue selling when out of stock") supply is
  // effectively unlimited from this configurator's point of view.
  function variantStockLimit(variant) {
    if (!variant) return 0;
    if (variant.inventory_management !== 'shopify') return Infinity;
    if (variant.inventory_policy === 'continue') return Infinity;
    return typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : Infinity;
  }

  function parseJSONObject(value, fallback) {
    try {
      var parsed = JSON.parse(value || '');
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : fallback;
    } catch (e) {
      return fallback;
    }
  }

  function parseJSONArray(value, fallback) {
    try {
      var parsed = JSON.parse(value || '');
      return Array.isArray(parsed) ? parsed : fallback;
    } catch (e) {
      return fallback;
    }
  }

  function normalizeKey(value) {
    return (value || '')
      .toLowerCase()
      .trim()
      .replace(/[-_]+/g, ' ')
      .replace(/\s+/g, ' ');
  }

  function capitalizeFirst(value) {
    var trimmed = (value || '').trim();
    return trimmed ? trimmed.charAt(0).toUpperCase() + trimmed.slice(1) : trimmed;
  }

  // Derives a matching key ("corner turmeric yellow") from a top-view asset
  // URL (".../seat-top-corner-turmeric-yellow.png?v=123"). Ported verbatim
  // from product-seat-configurator.js's seatTopKeyFromUrl.
  function seatTopKeyFromUrl(url) {
    var path = url.split('?')[0];
    var base = path.split('/').pop() || '';
    return base
      .replace(/^seat-top-/, '')
      .replace(/\.[a-z0-9]+$/i, '')
      .replace(/-/g, ' ');
  }

  // Derives a matching key ("fern green") from a swatch asset URL
  // (".../swatch-fern-green.jpg?v=123"). Ported verbatim.
  function swatchKeyFromUrl(url) {
    var path = url.split('?')[0];
    var base = path.split('/').pop() || '';
    return base
      .replace(/^swatch-/, '')
      .replace(/\.[a-z0-9]+$/i, '')
      .replace(/-/g, ' ');
  }

  // A Color value may match a fabric photo by name (exact or partial, e.g.
  // "Fern" matches "fern green"), otherwise falls back to a solid hex color
  // if one is configured, otherwise no swatch is shown. Ported verbatim.
  function resolveColorSwatch(value, fabricSwatches) {
    var key = normalizeKey(value);
    if (!key) return null;

    if (fabricSwatches[key]) return { type: 'image', src: fabricSwatches[key] };
    for (var fabricKey in fabricSwatches) {
      if (fabricKey.indexOf(key) !== -1 || key.indexOf(fabricKey) !== -1) {
        return { type: 'image', src: fabricSwatches[fabricKey] };
      }
    }

    if (COLOR_HEX_BY_VALUE[key]) return { type: 'color', hex: COLOR_HEX_BY_VALUE[key] };

    return null;
  }

  function turn(heading, cw) {
    var i = ORDER.indexOf(heading);
    return ORDER[(i + (cw ? 1 : 3)) % 4];
  }
  function leftOf(heading) {
    return turn(heading, false);
  }
  function opposite(heading) {
    return ORDER[(ORDER.indexOf(heading) + 2) % 4];
  }
  function complement(a, b) {
    return ORDER.filter(function (d) {
      return d !== a && d !== b;
    });
  }

  // Walk the chain on a grid, heading east to start. A corner seat turns the
  // chain 90 degrees in its own direction ('R' clockwise / 'L' counter-
  // clockwise). Corner backrests always sit on the two edges NOT used to
  // join a neighbour, so a joint can never be walled off by a backrest.
  // Ported verbatim from product-seat-configurator.js's layout().
  function layout(ori, turns) {
    var cells = [];
    var x = 0;
    var y = 0;
    var heading = 'E';
    for (var i = 0; i < ori.length; i++) {
      var cell = { i: i, x: x, y: y, type: ori[i], backs: [] };
      if (ori[i] === 'A') {
        cell.backs = [leftOf(heading)];
      } else if (i === 0) {
        cell.backs = complement('E', turns[i] === 'R' ? 'S' : 'N');
      } else {
        var prevSide = opposite(heading);
        heading = turn(heading, turns[i] === 'R');
        cell.backs = complement(prevSide, heading);
      }
      cells.push(cell);
      x += DIRS[heading][0];
      y += DIRS[heading][1];
    }
    return cells;
  }

  function collides(cells) {
    var seen = {};
    for (var i = 0; i < cells.length; i++) {
      var k = cells[i].x + ',' + cells[i].y;
      if (seen[k]) return true;
      seen[k] = true;
    }
    return false;
  }

  // Alternate R / L over the turning corners (the leading end cap does not
  // turn, so it does not participate) - this staircase shape never overlaps.
  function safeTurns(ori) {
    var turns = [];
    var cw = true;
    for (var i = 0; i < ori.length; i++) {
      turns[i] = 'R';
      if (ori[i] === 'C' && i > 0) {
        turns[i] = cw ? 'R' : 'L';
        cw = !cw;
      }
    }
    return turns;
  }

  function edgeRect(dir, x, y, s) {
    var t = 11;
    if (dir === 'N') return { x: x, y: y, w: s, h: t };
    if (dir === 'S') return { x: x, y: y + s - t, w: s, h: t };
    if (dir === 'W') return { x: x, y: y, w: t, h: s };
    return { x: x + s - t, y: y, w: t, h: s };
  }

  function resolveCollisions(perModule) {
    var ori = perModule.map(function (s) {
      return s.type;
    });
    var turns = perModule.map(function (s) {
      return s.turn;
    });
    if (collides(layout(ori, turns))) {
      var safe = safeTurns(ori);
      perModule.forEach(function (s, i) {
        if (s.type === 'C') s.turn = safe[i];
      });
    }
    return perModule;
  }

  // Rotation (degrees) that moves an image authored with its backrest at the
  // top (N) - and, for corners, its arm at the left (W) - onto the cell's
  // actual back edges from layout(). Ported verbatim.
  function seatImageRotation(cell, seatType) {
    var has = {};
    cell.backs.forEach(function (d) {
      has[d] = true;
    });
    if (seatType === 'C') {
      if (has.N && has.W) return 0;
      if (has.N && has.E) return 90;
      if (has.S && has.E) return 180;
      if (has.S && has.W) return 270;
      return 0;
    }
    if (has.E) return 90;
    if (has.S) return 180;
    if (has.W) return 270;
    return 0;
  }

  // Sets a slot's structural geometry fields from its shape_type - port of
  // product-seat-configurator.js's applyOrientationValue, sourcing from
  // SHAPE_TYPE_TABLE instead of a free-text Orientation option value.
  function applyShapeType(slot, shapeType) {
    var key = (shapeType || '').toLowerCase().trim();
    var preset = SHAPE_TYPE_TABLE[key];
    slot.shapeType = shapeType || null;
    if (!preset) {
      slot.type = 'A';
      slot.turn = 'R';
      slot.chaise = false;
      slot.armSide = null;
      return;
    }
    slot.type = preset.type;
    slot.turn = preset.turn || 'R';
    slot.chaise = !!preset.chaise;
    slot.armSide = preset.armSide || null;
  }

  class ModularConfigurator extends HTMLElement {
    connectedCallback() {
      var dataScript = this.querySelector('[data-module-data]');
      this.moduleData = parseJSONObject(dataScript ? dataScript.textContent : '', {});
      this.roles = Object.keys(this.moduleData);

      var seatPresetsScript = this.querySelector('[data-seat-layout-presets]');
      this.seatLayoutPresets = parseJSONObject(seatPresetsScript ? seatPresetsScript.textContent : '', {});
      // Sorted by seat_count so pills read low-to-high; presets sharing the
      // same seat_count (e.g. two different 1-seat combos) keep the order
      // the merchant configured them in, since Object.keys() preserves
      // insertion order and the sort below is stable.
      var presets = this.seatLayoutPresets;
      this.presetKeys = Object.keys(presets).sort(function (a, b) {
        return (presets[a].seat_count || 0) - (presets[b].seat_count || 0);
      });
      // Once a shell product has real seat-count presets configured, the
      // "Seats" picker takes over choosing slot count and the freeform
      // add/remove controls go away (matches the old Seats-variant
      // interaction: picking a count locks how many seats there are). Shell
      // products with no presets configured yet keep today's freeform
      // behavior untouched, so this can ship without a rollout dependency
      // across every shell product at once.
      this.locked = this.presetKeys.length > 0;
      this.selectedPresetKey = null;

      this.canvas = this.querySelector('[data-preview-canvas]');
      this.seatTopImages = {};
      var seatTopScript = this.querySelector('[data-seat-top-urls]');
      parseJSONArray(seatTopScript ? seatTopScript.textContent : '', []).forEach((url) => {
        this.seatTopImages[seatTopKeyFromUrl(url)] = url;
      });

      this.fabricSwatches = {};
      var fabricScript = this.querySelector('[data-fabric-swatch-urls]');
      parseJSONArray(fabricScript ? fabricScript.textContent : '', []).forEach((url) => {
        this.fabricSwatches[swatchKeyFromUrl(url)] = url;
      });

      // seat count (string) -> this shell product's own media id for that
      // count's gallery photography - see data-shell-seat-media in
      // product-block-modular-configurator.liquid. Not every count is
      // guaranteed an entry yet (merchant may not have assigned gallery media
      // to that Seats variant), so syncGalleryToSeatCount() below is a no-op
      // when one is missing.
      var shellSeatMediaScript = this.querySelector('[data-shell-seat-media]');
      this.shellSeatMedia = parseJSONObject(shellSeatMediaScript ? shellSeatMediaScript.textContent : '', {});

      this.seatCountPickerEl = this.querySelector('[data-seat-count-picker]');
      this.slotsEl = this.querySelector('[data-module-slots]');
      this.addSlotBtn = this.querySelector('[data-add-slot]');
      this.errorEl = this.querySelector('[data-bundle-error]');
      this.sectionId = this.dataset.section || '';
      this.priceTarget = this.dataset.priceTarget || '';
      this.priceStickyTarget = this.dataset.priceStickyTarget || '';
      this.expandSeatsDefault = this.dataset.expandSeatsDefault !== 'false';

      this.i18n = {
        moduleComboTitle:
          this.dataset.i18nModuleComboTitle || 'Seat {index} · {role} - {color}',
        notSet: this.dataset.i18nNotSet || 'Not set',
        rotate: this.dataset.i18nRotate || 'Rotate',
        missingVariant:
          this.dataset.i18nMissingVariant ||
          "One or more of your module selections isn't available yet.",
        genericError:
          this.dataset.i18nGenericError || 'Something went wrong adding this to your cart.',
        saveAmount: this.dataset.i18nSaveAmount || 'Save __AMOUNT__',
      };

      // perModule: one entry per configured module slot, in the order they'll
      // be added to the cart. `colorValue` is resolved via default_color /
      // fallback_priority so a slot never starts out pointing at an
      // out-of-stock variant.
      this.perModule = [];

      if (this.locked) {
        if (this.addSlotBtn) this.addSlotBtn.hidden = true;
        this.buildSeatCountPicker();
        // data-default-preset-key (see product-block-modular-configurator.liquid)
        // lets a merchant pick which preset shows on page load instead of
        // always the lowest seat_count one; falls back to that same
        // lowest-seat_count behavior when unset or stale (pointing at a
        // preset key this product no longer lists). A ?seats=<n> URL param
        // (e.g. a marketing CTA linking to /products/ridge?seats=1) takes
        // priority over both - see presetKeyFromSeatsParam().
        var defaultKey = this.dataset.defaultPresetKey;
        var seatsParamKey = this.presetKeyFromSeatsParam();
        var initialKey = seatsParamKey
          || (defaultKey && this.presetKeys.indexOf(defaultKey) !== -1 ? defaultKey : this.presetKeys[0]);
        this.selectPreset(initialKey);
      } else {
        if (this.addSlotBtn) {
          this.addSlotBtn.addEventListener('click', () => this.addSlot());
        }
        if (this.roles.length) {
          this.addSlot();
        }
        this.renderAll(true);
      }

      this.setupBundleSubmit();

      // Selecting/declining the upsell offer changes what updateComputedPrice()
      // should total - see product-upsell-offer.js, which dispatches this on
      // the upsell-offer element (bubbles to document since it's a sibling
      // block, not a descendant of this element).
      document.addEventListener('upsell-offer:change', () => {
        this.updateComputedPrice();
        this.notifyChange();
      });
    }

    // The order-quantity multiplier applied to every module line item (see
    // buildModuleCartItems) - a variant claimed by N slots at order quantity
    // Q needs N * Q units in stock, not just N.
    currentQuantity() {
      var qty = this.quantityInput ? parseInt(this.quantityInput.value, 10) : 1;
      return qty > 0 ? qty : 1;
    }

    // How many slots currently resolve to each variant id. `skipIndex`
    // excludes one slot from the count - used when checking whether a
    // *candidate* pick for that slot would be legal, since the slot's own
    // current pick shouldn't count against itself.
    demandByVariantId(skipIndex) {
      var demand = {};
      this.perModule.forEach((slot, i) => {
        if (i === skipIndex) return;
        var variant = this.resolveVariant(slot);
        if (variant) demand[variant.id] = (demand[variant.id] || 0) + 1;
      });
      return demand;
    }

    // Tries `preferredColor` first (e.g. a seat-count preset's per-slot
    // color pick), then the role's own configured default color; if that
    // variant is unavailable *or* already fully claimed by other slots in
    // this same order (see `claimed`/`qty` below), walks fallback_priority
    // in order for the first color that still has room; failing that,
    // takes the first color with room at all. Returns null only when every
    // variant for this role is unavailable or fully claimed.
    // `preferredColor` is optional - omitting it (or passing a blank/
    // unavailable/claimed-out color) falls straight through to the existing
    // default_color/fallback_priority chain. `claimed` (variant id -> slots
    // already claiming it so far) and `qty` are optional too - callers
    // adjusting a single existing slot pass the current cross-slot demand
    // (excluding that slot itself) so a role/count change doesn't silently
    // double-book a colour another slot already has locked in.
    resolveAvailableColor(role, preferredColor, claimed, qty) {
      var mod = this.moduleData[role];
      if (!mod) return null;
      var variants = mod.variants || {};
      claimed = claimed || {};
      qty = qty || this.currentQuantity();

      var fits = function (color) {
        var variant = variants[color];
        if (!variant || !variant.available) return false;
        var limit = variantStockLimit(variant);
        if (limit === Infinity) return true;
        var already = claimed[variant.id] || 0;
        return (already + 1) * qty <= limit;
      };

      if (preferredColor && fits(preferredColor)) return preferredColor;

      if (mod.default_color && fits(mod.default_color)) return mod.default_color;

      var fallbackList = mod.fallback_priority || [];
      for (var i = 0; i < fallbackList.length; i++) {
        if (fits(fallbackList[i])) return fallbackList[i];
      }

      for (var anyColor in variants) {
        if (fits(anyColor)) return anyColor;
      }

      // Nothing currently has room (every color for this role is out of
      // stock, or already claimed by other slots at this order quantity) -
      // still resolve to *a* color instead of null, so the slot keeps its
      // top-view photo and role label. The caller/renderer marks this slot
      // unavailable via resolveVariant(slot).available, which greys out that
      // photo (see renderCanvas) rather than the slot losing its image and
      // label entirely.
      return preferredColor || mod.default_color || fallbackList[0] || Object.keys(variants)[0] || null;
    }

    // Rebuilds the whole slot array from a seat-layout preset (positional:
    // roles[i] -> slot i), replacing whatever was configured before - matches
    // the old Seats-variant interaction where picking a preset is a hard
    // reset, not an incremental add/remove. `key` is the preset's own
    // identity (see data-seat-layout-presets), not the seat count - multiple
    // presets can share the same seat_count and still be distinct pills.
    selectPreset(key) {
      var preset = this.seatLayoutPresets[key] || {};
      var roles = preset.roles || [];
      var colors = preset.colors || [];
      // Tracked and updated as slots are built below (not read from
      // this.perModule, which still holds the *previous* slot set until
      // this whole assignment finishes) so an earlier slot in this same
      // preset never gets silently double-booked against a later one.
      var claimed = {};
      var qty = this.currentQuantity();
      this.perModule = roles.map((role, i) => {
        var slot = { role: role, colorValue: this.resolveAvailableColor(role, colors[i], claimed, qty), previewAngle: 0 };
        applyShapeType(slot, (this.moduleData[role] || {}).shape_type);
        var variant = this.resolveVariant(slot);
        if (variant) claimed[variant.id] = (claimed[variant.id] || 0) + 1;
        return slot;
      });
      resolveCollisions(this.perModule);
      this.selectedPresetKey = key;
      this.updateSeatCountPicker();
      this.syncGalleryToPreset(preset);
      this.renderAll(true);
    }

    // Picking a Seats count here doesn't touch a real Shopify variant (the
    // slots are built from role/color metaobject data, not this shell
    // product's own options), so it never runs Shopify's native variant ->
    // gallery flow (VariantSelects.updateMedia()). This drives the same
    // gallery directly instead, using the shell product's own Seats-variant
    // media map (see data-shell-seat-media).
    //
    // Tries the preset's own `label` first (downcased) - this is the only
    // field that can distinguish two presets sharing the same seat_count
    // (e.g. Arc's Cove and Nook are both seat_count 1, so keying on count
    // alone can't tell their gallery media apart) - and falls back to
    // seat_count for shell products whose preset labels don't match their
    // Seats option values verbatim (see the shell_seat_media comment in
    // product-block-modular-configurator.liquid).
    syncGalleryToPreset(preset) {
      // Seat renders tagged by alt text (see snippets/product-gallery-filter.liquid):
      // keep only this seat's renders plus the shared shots, and land on its
      // first render.
      //
      // On a seat + module + color filtered gallery this configurator always
      // shows the preset's *default* configuration (its own roles and
      // colors), not the shopper's per-module edits - the same render
      // modular-configurator-v2 shows before any edit, and what Liquid
      // filters by on first paint. Per-module color/style picks only change
      // this configurator's own top-view canvas, never the gallery.
      if (typeof window.filterGalleryBySeatPreset === 'function') {
        var defaultColors = (preset.colors || []).filter(Boolean);
        var defaultRoles = (preset.roles || []).filter(Boolean);
        if (window.filterGalleryBySeatPreset(this.sectionId, preset, defaultColors, defaultRoles) != null) {
          this.showFirstGalleryMedia();
          return;
        }
      }

      if (typeof window.scrollGalleryToMedia !== 'function') return;
      var labelKey = preset.label ? String(preset.label).toLowerCase() : null;
      var mediaId = labelKey ? this.shellSeatMedia[labelKey] : null;
      if (!mediaId) mediaId = this.shellSeatMedia[String(preset.seat_count).toLowerCase()];
      if (!mediaId) return;
      window.scrollGalleryToMedia(this.sectionId, mediaId);
    }

    showFirstGalleryMedia() {
      var section = document.getElementById('MainProduct-' + this.sectionId);
      var list = section && section.querySelector('.product__media-list-wrapper > .js-media-list');
      if (!list) return;
      if (list.swiper) {
        list.swiper.slideTo(0);
      } else {
        list.scroll(0, 0);
      }
    }

    // ?seats=<n> on the URL (e.g. a marketing CTA linking to
    // /products/ridge?seats=1) lets a link pick which seat-count preset to
    // land on, matched by seat_count rather than a preset's own metaobject
    // id - so whoever builds the link doesn't need to know any
    // per-product preset ids. Takes priority over data-default-preset-key
    // (see the initialKey logic in connectedCallback). Returns null when
    // the param is missing/non-numeric or no configured preset has that
    // seat_count, leaving the existing default-key/lowest-seat_count
    // fallback in place.
    presetKeyFromSeatsParam() {
      var seatsParam = new URLSearchParams(window.location.search).get('seats');
      var seatsCount = parseInt(seatsParam, 10);
      if (!seatsCount) return null;

      for (var i = 0; i < this.presetKeys.length; i++) {
        var key = this.presetKeys[i];
        if (this.seatLayoutPresets[key].seat_count === seatsCount) return key;
      }
      return null;
    }

    buildSeatCountPicker() {
      // The "Seats" step title is static Liquid output (see the
      // seats_step_heading block setting in
      // snippets/product-block-modular-configurator.liquid) - this only
      // ever populates the sibling [data-seat-count-picker] div, not the
      // title, so a merchant's richtext heading survives every rebuild.
      if (!this.seatCountPickerEl) return;
      this.seatCountPickerEl.innerHTML = '';

      var group = document.createElement('div');
      group.className = 'seat-configurator__option-group';
      this.presetKeys.forEach((key) => {
        var preset = this.seatLayoutPresets[key] || {};
        var id = 'ModularSeatCount-' + this.sectionId + '-' + key;
        var seatCount = preset.seat_count;

        var input = document.createElement('input');
        input.type = 'radio';
        input.name = 'modular-seat-count-' + this.sectionId;
        input.id = id;
        input.value = key;
        input.checked = key === this.selectedPresetKey;
        input.addEventListener('change', () => this.selectPreset(key));
        group.appendChild(input);

        var labelEl = document.createElement('label');
        labelEl.setAttribute('for', id);
        labelEl.textContent = preset.label || seatCount + ' Seat' + (seatCount > 1 ? 's' : '');
        group.appendChild(labelEl);
      });
      this.seatCountPickerEl.appendChild(group);
    }

    updateSeatCountPicker() {
      if (!this.seatCountPickerEl) return;
      this.seatCountPickerEl.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.checked = input.value === this.selectedPresetKey;
      });
    }

    addSlot() {
      if (!this.roles.length) return;
      var role = this.roles[0];
      var slot = {
        role: role,
        colorValue: this.resolveAvailableColor(role, null, this.demandByVariantId(), this.currentQuantity()),
        previewAngle: 0,
      };
      applyShapeType(slot, (this.moduleData[role] || {}).shape_type);
      this.perModule.push(slot);
      resolveCollisions(this.perModule);
      this.renderAll(true);
    }

    removeSlot(index) {
      this.perModule.splice(index, 1);
      resolveCollisions(this.perModule);
      this.renderAll(true);
    }

    setSlotRole(index, role) {
      var claimed = this.demandByVariantId(index);
      this.perModule[index].role = role;
      this.perModule[index].colorValue = this.resolveAvailableColor(role, null, claimed, this.currentQuantity());
      applyShapeType(this.perModule[index], (this.moduleData[role] || {}).shape_type);
      resolveCollisions(this.perModule);
      this.renderAll(false);
    }

    setSlotColor(index, color) {
      this.perModule[index].colorValue = color;
      this.renderAll(false);
    }

    // Rotates a module's top-view preview. Corner modules flip their chain
    // turn (structural - checked for collisions, since it determines which
    // way the L-shape bends); every other module just spins its own preview
    // image in place, purely cosmetic. Port of product-seat-
    // configurator.js's rotateSeat.
    rotateSlot(index) {
      var slot = this.perModule[index];
      if (!slot) return;

      if (slot.type !== 'C') {
        slot.previewAngle = ((slot.previewAngle || 0) + 90) % 360;
        this.renderAll(false);
        return;
      }

      var prevTurn = slot.turn;
      slot.turn = prevTurn === 'R' ? 'L' : 'R';

      var ori = this.perModule.map(function (s) {
        return s.type;
      });
      var turns = this.perModule.map(function (s) {
        return s.turn;
      });
      if (collides(layout(ori, turns))) {
        slot.turn = prevTurn;
        return;
      }
      this.renderAll(false);
    }

    renderAll(rebuildRows) {
      this.renderCanvas();
      this.renderModuleRows(rebuildRows);
      this.updateComputedPrice();
      this.updateInventoryNote();
      this.notifyChange();
    }

    // Broadcasts the current configuration as checkout-ready variant
    // quantities, for blocks that live outside this element and can't share
    // its state - e.g. the modular_shop_pay_button block
    // (assets/modular-shop-pay.js). Also kept on `this.lastChange` so a
    // listener that upgrades after the first render can read it directly.
    // `variants` is [] whenever the configuration can't be bought as-is.
    notifyChange() {
      var available = this.hasSufficientStock();
      var qty = this.currentQuantity();
      var byId = {};
      var order = [];
      var add = function (id, quantity) {
        if (!id || !quantity) return;
        if (!byId[id]) {
          byId[id] = 0;
          order.push(id);
        }
        byId[id] += quantity;
      };

      if (available) {
        this.perModule.forEach((slot) => {
          var variant = this.resolveVariant(slot);
          if (variant) add(variant.id, qty);
        });
        if (typeof window.collectUpsellCartItems === 'function') {
          window.collectUpsellCartItems().forEach(function (item) {
            add(item.id, item.quantity);
          });
        }
      }

      this.lastChange = {
        sectionId: this.sectionId,
        available: available,
        variants: order.map(function (id) {
          return { id: id, quantity: byId[id] };
        }),
      };
      this.dispatchEvent(new CustomEvent('modular-configurator:change', { bubbles: true, detail: this.lastChange }));
    }

    // True when every currently configured slot resolves to a variant that
    // both has stock at all *and* isn't already oversubscribed once every
    // slot claiming it (times the order quantity) is added up - the same
    // aggregate-demand check the swatch picker uses to grey out choices,
    // applied here to the configuration as a whole (including slots the
    // shopper never touched, e.g. straight from a seat-count preset).
    hasSufficientStock() {
      if (!this.perModule.length) return false;
      var qty = this.currentQuantity();
      var demand = {};
      var allResolved = true;

      this.perModule.forEach((slot) => {
        var variant = this.resolveVariant(slot);
        if (!variant || !variant.available) {
          allResolved = false;
          return;
        }
        demand[variant.id] = demand[variant.id] || { count: 0, variant: variant };
        demand[variant.id].count += 1;
      });

      if (!allResolved) return false;

      return Object.keys(demand).every((id) => {
        var entry = demand[id];
        var limit = variantStockLimit(entry.variant);
        return limit === Infinity || entry.count * qty <= limit;
      });
    }

    // True when any currently configured slot resolves to a variant flagged
    // with the custom.extended_lead_time metafield (see variant_value_json
    // in product-block-modular-configurator.liquid) - a merchant-marked
    // "sellable but on a longer freight lead time" variant, e.g. a color
    // pre-sold ahead of its real restock. One flagged slot is enough to push
    // the whole order onto the longer timeline, since every slot ships
    // together.
    hasExtendedLeadTime() {
      return this.perModule.some((slot) => {
        var variant = this.resolveVariant(slot);
        return !!(variant && variant.extended_lead_time);
      });
    }

    // Mirrors the standard `inventory` block's dot-color states
    // (products__inventory-inner--empty for out-of-stock), but computed
    // from whether every currently configured module resolves to an
    // available variant with enough stock left to cover this order - this
    // shell product has no single "inventory quantity" of its own, so
    // there's no "low stock" (--error) tier here, only available vs. not.
    updateInventoryNote() {
      var el = document.getElementById('ModularInventory-' + this.sectionId);
      var inner = el ? el.querySelector('[data-modular-inventory-inner]') : null;
      if (!inner) return;

      inner.classList.toggle('product__inventory-inner--empty', !this.hasSufficientStock());
      inner.classList.toggle('product__inventory-inner--extended-lead', this.hasExtendedLeadTime());
    }

    // Finds the top-view photo for a role + color combination: exact key
    // first ("anchor-corner-1 turmeric yellow"), then a handle-only image
    // (e.g. an ottoman). Returns null when nothing fits, in which case the
    // cell falls back to the schematic shape. Keyed by the role's atomic
    // module product handle (this.moduleData[role].product_handle), not the
    // merchant-entered role name - see data-shell-seat-media in
    // product-block-modular-configurator.liquid for why (role names collide
    // across shell products, product handles never do). Falls back to the
    // role string itself if module data is missing for some reason.
    resolveSeatTopImage(role, colorValue) {
      var images = this.seatTopImages;
      var mod = this.moduleData[role];
      var handle = (mod && mod.product_handle) || role;
      var r = normalizeKey(handle);
      var c = normalizeKey(colorValue);
      if (!r) return null;

      if (c && images[r + ' ' + c]) return images[r + ' ' + c];
      if (images[r]) return images[r];
      return null;
    }

    // Builds the top-view SVG layout from this.perModule. Port of product-
    // seat-configurator.js's renderCanvas, keyed by role/shapeType instead
    // of orientationValue. Unlike the old version, every cell also renders
    // its schematic fallback group (hidden if a photo resolved) so a 404'd
    // <image> - photo URLs are now dynamically constructed from merchant
    // metaobject data rather than a hand-verified list - can be swapped to
    // it instead of showing a broken image.
    renderCanvas() {
      if (!this.canvas) return;
      if (!this.perModule.length) {
        this.canvas.innerHTML = '';
        return;
      }

      var ori = this.perModule.map(function (s) {
        return s.type;
      });
      var turns = this.perModule.map(function (s) {
        return s.turn;
      });
      var cells = layout(ori, turns);

      var minX = Infinity;
      var minY = Infinity;
      var maxX = -Infinity;
      var maxY = -Infinity;
      cells.forEach(function (c) {
        minX = Math.min(minX, c.x);
        maxX = Math.max(maxX, c.x);
        minY = Math.min(minY, c.y);
        maxY = Math.max(maxY, c.y);
      });
      var cols = maxX - minX + 1;
      var rows = maxY - minY + 1;
      var w = cols * CELL + (cols - 1) * GAP + PAD * 2;
      var h = rows * CELL + (rows - 1) * GAP + PAD * 2;

      // Namespaced per section so multiple configurators on one page (e.g.
      // theme editor previews) don't collide on the same <pattern> id.
      var stripesId = 'seat-stripes-' + this.sectionId;

      var svg = [
        '<svg class="seat-configurator__svg" width="' +
          w +
          '" height="' +
          h +
          '" viewBox="0 0 ' +
          w +
          ' ' +
          h +
          '" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Sofa layout preview">',
        '<defs><pattern id="' +
          stripesId +
          '" width="6" height="6" patternTransform="rotate(45)" patternUnits="userSpaceOnUse">' +
          '<rect width="6" height="6" class="seat-configurator__stripe-bg"/>' +
          '<line x1="0" y1="0" x2="0" y2="6" class="seat-configurator__stripe-line"/>' +
          '</pattern></defs>',
      ];

      var perModule = this.perModule;
      var imageCellIndexes = [];

      cells.forEach((c) => {
        var px = PAD + (c.x - minX) * (CELL + GAP);
        var py = PAD + (c.y - minY) * (CELL + GAP);
        var slot = perModule[c.i];
        var isC = slot.type === 'C';
        var isChaise = isC && slot.chaise;
        var suffix = isChaise ? '--chaise' : isC ? '--corner' : '';
        var typeLabel = isChaise
          ? 'Chaise'
          : isC
          ? 'Corner'
          : slot.armSide
          ? slot.armSide + ' arm'
          : 'Armless';

        var imageSrc = this.resolveSeatTopImage(slot.role, slot.colorValue);
        var variant = this.resolveVariant(slot);
        var isUnavailable = !variant || !variant.available;
        var cellClass = 'seat-configurator__cell' + (isUnavailable ? ' seat-configurator__cell--unavailable' : '');
        var deg = (seatImageRotation(c, slot.type) + (slot.previewAngle || 0)) % 360;
        var cx = px + CELL / 2;
        var cy = py + CELL / 2;
        // Diagonal-stripe overlay so "unavailable" reads correctly even over
        // a photo whose fabric already happens to be grey - plain
        // grayscale/opacity alone is ambiguous in that case.
        var stripeRect = isUnavailable
          ? '<rect class="seat-configurator__cell-stripes" x="' +
            px +
            '" y="' +
            py +
            '" width="' +
            CELL +
            '" height="' +
            CELL +
            '" rx="8" style="fill:url(#' +
            stripesId +
            ')"/>'
          : '';

        if (imageSrc) {
          imageCellIndexes.push(c.i);
          svg.push('<g class="' + cellClass + '" data-cell-image="' + c.i + '">');
          svg.push(
            '<g transform="rotate(' +
              deg +
              ' ' +
              cx +
              ' ' +
              cy +
              ')"><image href="' +
              imageSrc +
              '" x="' +
              px +
              '" y="' +
              py +
              '" width="' +
              CELL +
              '" height="' +
              CELL +
              '" preserveAspectRatio="xMidYMid meet"/>' +
              stripeRect +
              '</g>'
          );
          svg.push(
            '<circle class="seat-configurator__cell-badge" cx="' +
              (px + 12) +
              '" cy="' +
              (py + 12) +
              '" r="9"/>'
          );
          svg.push(
            '<text class="seat-configurator__cell-badge-num" x="' +
              (px + 12) +
              '" y="' +
              (py + 15.5) +
              '" text-anchor="middle">' +
              (c.i + 1) +
              '</text>'
          );
          svg.push('</g>');
        }

        svg.push(
          '<g class="' +
            cellClass +
            '" data-cell-schematic="' +
            c.i +
            '"' +
            (imageSrc ? ' style="display:none"' : '') +
            '>'
        );
        svg.push('<g transform="rotate(' + deg + ' ' + cx + ' ' + cy + ')">');
        svg.push(
          '<rect class="seat-configurator__cell-rect seat-configurator__cell-rect' +
            suffix +
            '" x="' +
            px +
            '" y="' +
            py +
            '" width="' +
            CELL +
            '" height="' +
            CELL +
            '" rx="8"/>' +
            stripeRect
        );

        c.backs.forEach(function (d) {
          var r = edgeRect(d, px + 3, py + 3, CELL - 6);
          svg.push(
            '<rect class="seat-configurator__cell-back seat-configurator__cell-back' +
              suffix +
              '" x="' +
              r.x +
              '" y="' +
              r.y +
              '" width="' +
              r.w +
              '" height="' +
              r.h +
              '" rx="4"/>'
          );
        });
        svg.push('</g>');

        svg.push(
          '<text class="seat-configurator__cell-num seat-configurator__cell-num' +
            suffix +
            '" x="' +
            (px + CELL / 2) +
            '" y="' +
            (py + CELL / 2 + 1) +
            '" text-anchor="middle">' +
            (c.i + 1) +
            '</text>'
        );
        svg.push(
          '<text class="seat-configurator__cell-type seat-configurator__cell-type' +
            suffix +
            '" x="' +
            (px + CELL / 2) +
            '" y="' +
            (py + CELL / 2 + 17) +
            '" text-anchor="middle">' +
            typeLabel.toUpperCase() +
            '</text>'
        );

        svg.push('</g>');
      });

      svg.push('</svg>');
      this.canvas.innerHTML = svg.join('');

      imageCellIndexes.forEach((i) => {
        var imageGroup = this.canvas.querySelector('[data-cell-image="' + i + '"]');
        var imageEl = imageGroup ? imageGroup.querySelector('image') : null;
        if (!imageEl) return;
        imageEl.addEventListener('error', () => {
          var schematicGroup = this.canvas.querySelector('[data-cell-schematic="' + i + '"]');
          imageGroup.style.display = 'none';
          if (schematicGroup) schematicGroup.style.display = '';
        });
      });
    }

    // Port of product-seat-configurator.js's renderSeatRows: diffs the
    // existing <details> accordion rows against this.perModule.length,
    // rebuilding from scratch only when rebuildRows is true and the count
    // actually changed - so in-place edits (role/color/rotate) don't collapse
    // rows a shopper already has open.
    renderModuleRows(rebuildRows) {
      if (!this.slotsEl) return;

      var rows = Array.prototype.slice.call(this.slotsEl.children);

      if (rebuildRows && rows.length !== this.perModule.length) {
        this.slotsEl.innerHTML = '';
        rows = [];
      }

      while (rows.length > this.perModule.length) {
        this.slotsEl.removeChild(rows.pop());
      }
      while (rows.length < this.perModule.length) {
        var details = document.createElement('details');
        details.className = 'seat-configurator__seat-row';
        details.open = this.expandSeatsDefault && rows.length === 0;

        var summary = document.createElement('summary');
        summary.className = 'seat-configurator__seat-summary';
        summary.innerHTML = '<span class="seat-configurator__seat-title"></span>' + CHEVRON_SVG;

        var content = document.createElement('div');
        content.className = 'seat-configurator__seat-content';

        details.appendChild(summary);
        details.appendChild(content);
        this.slotsEl.appendChild(details);
        rows.push(details);
      }

      rows.forEach((details, i) => this.updateModuleRow(details, i));
    }

    updateModuleRow(details, index) {
      var slot = this.perModule[index];
      // slot.colorValue may point at an out-of-stock variant (see
      // resolveAvailableColor's fallback) so the top-view photo/role stay
      // visible - but nothing is actually "selected" from the shopper's
      // perspective in that case, so the label and swatch highlighting below
      // both treat it as unset rather than showing the unavailable color.
      var variant = this.resolveVariant(slot);
      var colorAvailable = !!(variant && variant.available);

      var title = details.querySelector('.seat-configurator__seat-title');
      title.textContent = this.i18n.moduleComboTitle
        .replace('{index}', index + 1)
        .replace('{role}', (this.moduleData[slot.role] && this.moduleData[slot.role].product_title) || slot.role || this.i18n.notSet)
        .replace('{color}', colorAvailable ? slot.colorValue : this.i18n.notSet);

      var content = details.querySelector('.seat-configurator__seat-content');
      content.innerHTML = '';

      // True for a role that's a structurally-distinct, separately-sold
      // single-item product (e.g. Arc's Cove/Nook) rather than an
      // interchangeable "style" of one swappable role (e.g. Ridge's
      // Corner/Armless) - see entry.lock_style.value in
      // product-block-modular-configurator.liquid. Locked slots get a
      // static preview thumbnail instead of the Style pill row, and no
      // rotate button; Color stays fully pickable either way.
      var styleLocked = !!(this.moduleData[slot.role] && this.moduleData[slot.role].lock_style);

      if (styleLocked) {
        content.appendChild(this.buildLockedStylePreview(slot));
      } else if (this.roles.length) {
        content.appendChild(
          this.buildRoleGroup('Style', this.roles, slot.role, (value) => this.setSlotRole(index, value))
        );

        var roleRow = content.lastChild.querySelector('.seat-configurator__pill-row-buttons');
        var rotateBtn = document.createElement('button');
        rotateBtn.type = 'button';
        rotateBtn.className = 'seat-configurator__pill-rotate';
        rotateBtn.innerHTML = ROTATE_SVG;
        rotateBtn.title = this.i18n.rotate;
        rotateBtn.setAttribute('aria-label', this.i18n.rotate);
        rotateBtn.addEventListener('click', () => this.rotateSlot(index));
        roleRow.appendChild(rotateBtn);
      }

      var variants = (this.moduleData[slot.role] && this.moduleData[slot.role].variants) || {};
      var colors = Object.keys(variants);
      if (colors.length) {
        content.appendChild(
          this.buildColorSwatchGroup(
            'Color',
            colors,
            colorAvailable ? slot.colorValue : null,
            (value) => this.setSlotColor(index, value),
            (value) => this.isColorDisabled(slot.role, value, index),
            (value) => {
              var v = variants[value];
              return !v || !v.available;
            }
          )
        );
      }

      if (!this.locked) {
        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'modular-configurator__remove-slot';
        removeBtn.setAttribute('aria-label', 'Remove this module');
        removeBtn.textContent = 'Remove';
        removeBtn.addEventListener('click', () => this.removeSlot(index));
        content.appendChild(removeBtn);
      }
    }

    // True when picking `value` for the module at `index` isn't possible
    // right now - either the variant itself has no stock at all, or every
    // unit it does have is already spoken for by this order's other slots.
    // The slot's own current pick is never disabled (reselecting what's
    // already chosen can't make demand any worse).
    isColorDisabled(role, value, index) {
      var mod = this.moduleData[role];
      var variant = mod && mod.variants && mod.variants[value];
      if (!variant) return true;
      if (!variant.available) return true;

      var slot = this.perModule[index];
      if (slot && slot.colorValue === value) return false;

      var limit = variantStockLimit(variant);
      if (limit === Infinity) return false;

      var claimed = this.demandByVariantId(index)[variant.id] || 0;
      return (claimed + 1) * this.currentQuantity() > limit;
    }

    // Builds a group label like "Style: Corner" where only the value after
    // the colon is bold - the "Style"/"Color" prefix stays regular weight.
    buildGroupLabel(label, activeDisplay) {
      var labelEl = document.createElement('div');
      labelEl.className = 'seat-configurator__seat-group-label';
      labelEl.appendChild(document.createTextNode(label + ': '));

      var valueEl = document.createElement('span');
      valueEl.className = 'seat-configurator__seat-group-label-value';
      valueEl.textContent = activeDisplay;
      labelEl.appendChild(valueEl);

      return labelEl;
    }

    buildRoleGroup(label, values, activeValue, onPick) {
      var wrap = document.createElement('div');
      wrap.className = 'seat-configurator__seat-group';

      var activeDisplay =
        (this.moduleData[activeValue] && this.moduleData[activeValue].product_title) ||
        activeValue ||
        this.i18n.notSet;
      wrap.appendChild(this.buildGroupLabel(label, activeDisplay));

      var row = document.createElement('div');
      row.className = 'seat-configurator__pill-row-buttons';
      values.forEach((value) => {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.textContent = (this.moduleData[value] && this.moduleData[value].product_title) || value;
        btn.className =
          'seat-configurator__pill-btn' + (activeValue === value ? ' seat-configurator__pill-btn--on' : '');
        btn.setAttribute('aria-pressed', String(activeValue === value));
        btn.addEventListener('click', function () {
          onPick(value);
        });
        row.appendChild(btn);
      });
      wrap.appendChild(row);

      return wrap;
    }

    // Locked-style counterpart to buildRoleGroup(): a lock_style module
    // (e.g. Arc's Cove/Nook) is a structurally distinct, separately-sold
    // product, not an interchangeable style of one role - so this renders a
    // small static top-view thumbnail instead of a switchable pill row, and
    // appends no rotate button. Re-derives everything from `slot` on every
    // call just like buildRoleGroup/buildColorSwatchGroup - renderAll ->
    // updateModuleRow always rebuilds this from scratch, so picking a new
    // Color re-runs this and the thumbnail naturally re-resolves.
    buildLockedStylePreview(slot) {
      var wrap = document.createElement('div');
      wrap.className = 'seat-configurator__seat-group';

      var mod = this.moduleData[slot.role];
      var display = (mod && mod.product_title) || slot.role || this.i18n.notSet;
      wrap.appendChild(this.buildGroupLabel('Style', display));

      var preview = document.createElement('div');
      preview.className = 'seat-configurator__style-preview';
      var imageSrc = this.resolveSeatTopImage(slot.role, slot.colorValue);
      if (imageSrc) preview.style.backgroundImage = 'url(' + imageSrc + ')';
      wrap.appendChild(preview);

      return wrap;
    }

    // Renders each Color value as a square swatch - a fabric photo when the
    // value matches one of the prepared images, a solid hex color when one is
    // configured in COLOR_HEX_BY_VALUE, or a plain labelled square otherwise.
    // Ported from product-seat-configurator.js's buildColorSwatchGroup, plus
    // an optional `isDisabled(value)` predicate (new here - the old flow's
    // variants were never shared across slots in one order, so it never
    // needed this) that greys out and disables a swatch that's out of stock
    // or already fully claimed by this order's other slots.
    buildColorSwatchGroup(label, values, activeValue, onPick, isDisabled, isSoldOut) {
      var wrap = document.createElement('div');
      wrap.className = 'seat-configurator__seat-group';

      var activeDisplay = activeValue ? capitalizeFirst(activeValue) : this.i18n.notSet;
      wrap.appendChild(this.buildGroupLabel(label, activeDisplay));

      var row = document.createElement('div');
      row.className = 'seat-configurator__swatch-row';

      var fabricSwatches = this.fabricSwatches;
      values.forEach(function (value) {
        var swatch = resolveColorSwatch(value, fabricSwatches);
        var disabled = !!(isDisabled && isDisabled(value));

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className =
          'seat-configurator__swatch-btn' +
          (activeValue === value ? ' seat-configurator__swatch-btn--on' : '') +
          (disabled ? ' seat-configurator__swatch-btn--disabled' : '') +
          (isSoldOut && isSoldOut(value) ? ' seat-configurator__swatch-btn--soldout' : '');
        btn.setAttribute('aria-label', value);
        btn.setAttribute('aria-pressed', String(activeValue === value));
        btn.title = disabled ? value + ' - out of stock' : value;
        btn.disabled = disabled;

        var swatchEl = document.createElement('span');
        swatchEl.className = 'seat-configurator__swatch';
        if (swatch && swatch.type === 'image') {
          swatchEl.style.backgroundImage = 'url(' + swatch.src + ')';
        } else if (swatch && swatch.type === 'color') {
          swatchEl.style.backgroundColor = swatch.hex;
        }
        btn.appendChild(swatchEl);

        if (!disabled) {
          btn.addEventListener('click', function () {
            onPick(value);
          });
        }
        row.appendChild(btn);
      });
      wrap.appendChild(row);

      return wrap;
    }

    resolveVariant(slot) {
      var mod = this.moduleData[slot.role];
      if (!mod) return null;
      return (mod.variants && mod.variants[slot.colorValue]) || null;
    }

    // Mirrors product-seat-configurator.js's updateComputedPrice: replaces the
    // PDP's single-variant price with the sum of what each configured module
    // actually costs, since that's the number buildModuleCartItems() charges.
    updateComputedPrice() {
      var priceWrapper = this.priceTarget ? document.getElementById(this.priceTarget) : null;
      var stickyWrapper = this.priceStickyTarget ? document.getElementById(this.priceStickyTarget) : null;
      if (!priceWrapper && !stickyWrapper) return;

      var total = 0;
      var compareTotal = 0;
      var allFound = this.perModule.length > 0;

      this.perModule.forEach((slot) => {
        var variant = this.resolveVariant(slot);
        if (!variant) {
          allFound = false;
          return;
        }
        total += variant.price;
        compareTotal += variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price;
      });

      if (!allFound) return;

      // Fold in any selected modular_upsell_offer block (see
      // product-block-modular-upsell.liquid / product-upsell-offer.js) -
      // it's a sibling block, not a child of this element, so it's looked
      // up on the page rather than within this.perModule.
      document.querySelectorAll('upsell-offer').forEach((el) => {
        if (!el.quantity || !el.price) return;
        total += el.price * el.quantity;
        compareTotal += (el.compareAtPrice > el.price ? el.compareAtPrice : el.price) * el.quantity;
      });

      window.updateConfiguredPriceDisplay({
        priceWrapper: priceWrapper,
        stickyWrapper: stickyWrapper,
        total: total,
        compareTotal: compareTotal,
        sectionId: this.sectionId,
        saveAmountTemplate: this.i18n.saveAmount,
      });
    }

    buildModuleCartItems(quantity) {
      // Final safety net - the swatch picker already disables choices that
      // would oversubscribe a variant, but this re-checks the full
      // configuration against real stock right before submit (e.g. in case
      // the shopper bumped the order quantity after picking colors).
      if (!this.hasSufficientStock()) return null;

      var bundleId = 'mc-' + Date.now() + '-' + Math.floor(Math.random() * 100000);
      var items = [];

      for (var i = 0; i < this.perModule.length; i++) {
        var variant = this.resolveVariant(this.perModule[i]);

        items.push({
          id: variant.id,
          quantity: quantity,
          properties: {
            _bundle_id: bundleId,
            _bundle_index: i + 1,
            _bundle_total: this.perModule.length,
            _bundle_title: this.dataset.bundleTitle || '',
          },
        });
      }

      return items;
    }

    setupBundleSubmit() {
      var form = document.getElementById('product-form-' + this.sectionId);
      if (!form) return;
      var submitBtn = form.querySelector('[name="add"]');
      if (!submitBtn) return;

      this.form = form;
      this.submitBtn = submitBtn;
      // Lives in the modular_shipping_note block, not inside this form (it's
      // only form-associated via its `form="..."` attribute), so it must be
      // looked up by id rather than via form.querySelector.
      this.quantityInput = document.getElementById('Quantity-' + this.sectionId);

      // Demand vs. stock scales with order quantity (see currentQuantity),
      // so bumping the stepper can turn an already-picked color into an
      // over-quota one - re-render to refresh swatch disabled-states and
      // the shipping note.
      if (this.quantityInput) {
        this.quantityInput.addEventListener('change', () => this.renderAll(false));
      }

      submitBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        window.submitCartBundle({
          form: this.form,
          submitBtn: this.submitBtn,
          errorEl: this.errorEl,
          quantityInput: this.quantityInput,
          buildItems: (quantity) => {
            var items = this.buildModuleCartItems(quantity);
            if (!items) return items;
            // See assets/product-upsell-offer.js - folds a selected
            // modular_upsell_offer block's variant into this same bundle so
            // it's added to cart in the same request as the main product.
            if (typeof window.collectUpsellCartItems === 'function') {
              items = items.concat(window.collectUpsellCartItems());
            }
            return items;
          },
          i18n: this.i18n,
          source: 'modular-configurator',
        });
      });
    }
  }

  customElements.define('modular-configurator', ModularConfigurator);
})();
